import { render, staticRenderFns } from "./ViAlertsAndNotifications.vue?vue&type=template&id=e9bf7f94"
import script from "./ViAlertsAndNotifications.vue?vue&type=script&lang=js"
export * from "./ViAlertsAndNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports